import React, { useState, useEffect } from 'react';
import { Modal, Button, Form, InputGroup, Table, Badge, Spinner } from 'react-bootstrap';
import { FaSearch, FaFilter, FaUserCheck, FaUserTie, FaUsers, FaSyncAlt } from 'react-icons/fa';

const CollaborationModal = ({ show, onHide, evenementId, token }) => {
    const [isLoading, setIsLoading] = useState(false);
    const [membres, setMembres] = useState([]);
    const [filteredMembres, setFilteredMembres] = useState([]);
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    const [searchTerm, setSearchTerm] = useState('');
    const [selectedType, setSelectedType] = useState('all'); // 'all', '1', '2', '3'

    // const staticMembres  = [
    //     {
    //         id: 1,
    //         ref_compte: "CPT-00001",
    //         pseudo: "john_doe",
    //         nom: "Dupont",
    //         prenoms: "Jean",
    //         telephone: "+22997123456",
    //         email: "jean.dupont@email.com",
    //         type_collaboration: "2",
    //         type_label: "Comité d'organisation",
    //         ref_collaboration: "COLLAB-EVT-00001-O001",
    //         statut_collaboration: "2",
    //         statut_label: "Actif",
    //         date_ajout: "2026-04-01T10:00:00Z"
    //     },
    //     {
    //         id: 2,
    //         ref_compte: "CPT-00002",
    //         pseudo: "jane_smith",
    //         nom: "Smith",
    //         prenoms: "Jane",
    //         telephone: "+22997123457",
    //         email: "jane.smith@email.com",
    //         type_collaboration: "1",
    //         type_label: "Comité de contrôle",
    //         ref_collaboration: "COLLAB-EVT-00001-C002",
    //         statut_collaboration: "2",
    //         statut_label: "Actif",
    //         date_ajout: "2026-04-02T11:30:00Z"
    //     },
    //     {
    //         id: 3,
    //         ref_compte: "CPT-00003",
    //         pseudo: "mike_wilson",
    //         nom: "Wilson",
    //         prenoms: "Mike",
    //         telephone: "+22997123458",
    //         email: "mike.wilson@email.com",
    //         type_collaboration: "3",
    //         type_label: "Contrôle + Organisation",
    //         ref_collaboration: "COLLAB-EVT-00001-B003",
    //         statut_collaboration: "1",
    //         statut_label: "Invité",
    //         date_ajout: "2026-04-03T09:15:00Z"
    //     },
    //     {
    //         id: 4,
    //         ref_compte: "CPT-00004",
    //         pseudo: "sarah_connor",
    //         nom: "Connor",
    //         prenoms: "Sarah",
    //         telephone: "+22997123459",
    //         email: "sarah.connor@email.com",
    //         type_collaboration: "2",
    //         type_label: "Comité d'organisation",
    //         ref_collaboration: "COLLAB-EVT-00001-O004",
    //         statut_collaboration: "2",
    //         statut_label: "Actif",
    //         date_ajout: "2026-04-04T14:20:00Z"
    //     },
    //     {
    //         id: 5,
    //         ref_compte: "CPT-00005",
    //         pseudo: "pierre_martin",
    //         nom: "Martin",
    //         prenoms: "Pierre",
    //         telephone: "+22997123460",
    //         email: "pierre.martin@email.com",
    //         type_collaboration: "1",
    //         type_label: "Comité de contrôle",
    //         ref_collaboration: "COLLAB-EVT-00001-C005",
    //         statut_collaboration: "1",
    //         statut_label: "Invité",
    //         date_ajout: "2026-04-05T08:45:00Z"
    //     },
    //     {
    //         id: 6,
    //         ref_compte: "CPT-00006",
    //         pseudo: "marie_laurent",
    //         nom: "Laurent",
    //         prenoms: "Marie",
    //         telephone: "+22997123461",
    //         email: "marie.laurent@email.com",
    //         type_collaboration: "3",
    //         type_label: "Contrôle + Organisation",
    //         ref_collaboration: "COLLAB-EVT-00001-B006",
    //         statut_collaboration: "2",
    //         statut_label: "Actif",
    //         date_ajout: "2026-04-06T16:00:00Z"
    //     },
    //     {
    //         id: 7,
    //         ref_compte: "CPT-00007",
    //         pseudo: "lucas_bernard",
    //         nom: "Bernard",
    //         prenoms: "Lucas",
    //         telephone: "+22997123462",
    //         email: "lucas.bernard@email.com",
    //         type_collaboration: "2",
    //         type_label: "Comité d'organisation",
    //         ref_collaboration: "COLLAB-EVT-00001-O007",
    //         statut_collaboration: "1",
    //         statut_label: "Invité",
    //         date_ajout: "2026-04-07T10:30:00Z"
    //     },
    //     {
    //         id: 8,
    //         ref_compte: "CPT-00008",
    //         pseudo: "emma_robert",
    //         nom: "Robert",
    //         prenoms: "Emma",
    //         telephone: "+22997123463",
    //         email: "emma.robert@email.com",
    //         type_collaboration: "1",
    //         type_label: "Comité de contrôle",
    //         ref_collaboration: "COLLAB-EVT-00001-C008",
    //         statut_collaboration: "2",
    //         statut_label: "Actif",
    //         date_ajout: "2026-04-08T13:15:00Z"
    //     }
    // ]

    // Types de collaboration
    const typesCollaboration = [
        { value: 'all', label: 'Tous', icon: <FaUsers className="me-1" />, color: 'secondary' },
        { value: '1', label: 'Comité de contrôle', icon: <FaUserCheck className="me-1" />, color: 'info' },
        { value: '2', label: "Comité d'organisation", icon: <FaUserTie className="me-1" />, color: 'primary' },
        { value: '3', label: 'Contrôle + Organisation', icon: <FaUsers className="me-1" />, color: 'success' }
    ];

    // Récupérer les membres
    const fetchMembres = async () => {
        if (!evenementId) return;

        setLoading(true);
        setError(null);

        try {
            const token = localStorage.getItem('access_token')
            const response = await fetch(
                `${process.env.REACT_APP_HOTE}api/liste-collaborateurs-evenement/${evenementId}/`,
                {
                    method: 'GET',
                    headers: {
                        'Authorization': `Bearer ${token}`,
                        'Content-Type': 'application/json',
                    },
                }
            );

            if (response.ok) {
                const data = await response.json();

                const collaborateurs = data.data || [];

                setMembres(collaborateurs);
                setFilteredMembres(collaborateurs);
            } else {
                const errorData = await response.json();
                setError(errorData.message || "Erreur lors du chargement des membres");

                // // Fallback aux données statiques en cas d'erreur à retirer
                // setMembres(staticMembres);
                // setFilteredMembres(staticMembres);
            }
        } catch (error) {
            console.error('Erreur réseau:', error);
            setError("Impossible de charger la liste des membres");

            // // Fallback aux données statiques à retirer
            // setMembres(staticMembres);
            // setFilteredMembres(staticMembres);
        } finally {
            setLoading(false);
        }
    };

    // // Charger les données statiques directement (sans API) à retirer
    // const loadStaticData = () => {
    //     setMembres(staticMembres);
    //     setFilteredMembres(staticMembres);
    //     setLoading(false);
    //     setError(null);
    // };
    // const [useApi, setUseApi] = useState(false);  // ← Mode API ou statique

    // // Rafraîchir les données quand le modal s'ouvre
    // useEffect(() => {
    //     if (show && evenementId) {
    //        if (useApi) {
    //             fetchMembres();
    //         } else {
    //             loadStaticData();
    //         }
    //     }
    // }, [show, evenementId, useApi]);

    useEffect(() => {
        if (show && evenementId) {
            fetchMembres();
        }
    }, [show, evenementId]);

    // Filtrer les membres
    useEffect(() => {
        let resultats = [...membres];

        // Filtre par type
        if (selectedType !== 'all') {
            resultats = resultats.filter(m => m.type_collaboration === selectedType);
        }

        // Filtre par recherche
        if (searchTerm.trim() !== '') {
            const term = searchTerm.toLowerCase().trim();
            resultats = resultats.filter(m =>
                (m.pseudo && m.pseudo.toLowerCase().includes(term)) ||
                (m.telephone && m.telephone.toLowerCase().includes(term)) ||
                (m.ref_compte && m.ref_compte.toLowerCase().includes(term)) ||
                (m.ref_collaboration && m.ref_collaboration.toLowerCase().includes(term))
            );
        }

        setFilteredMembres(resultats);
    }, [membres, searchTerm, selectedType]);

    // Obtenir le badge du type
    const getTypeBadge = (type) => {
        switch (type) {
            case '1':
                return { variant: 'warning', text: 'Comité de contrôle' };
            case '2':
                return { variant: 'primary', text: "Comité d'organisation" };
            case '3':
                return { variant: 'success', text: 'Contrôle + Organisation' };
            default:
                return { variant: 'secondary', text: 'Inconnu' };
        }
    };

    // Obtenir le badge du statut
    const getStatutBadge = (statut) => {
        switch (statut) {
            case '1':
                return { variant: 'warning', text: 'Invité' };
            case '2':
                return { variant: 'success', text: 'Actif' };
            case '3':
                return { variant: 'danger', text: 'Retiré' };
            default:
                return { variant: 'secondary', text: 'Inconnu' };
        }
    };

    return (
        <Modal show={show} onHide={onHide} size="lg" centered backdrop="static">
            <Modal.Header className="bg-light">
                <Modal.Title>
                    <FaUsers className="me-2 text-primary" />
                    Membres d'organisation
                </Modal.Title>
            </Modal.Header>

            <Modal.Body>
                {/* Barre de recherche et filtres */}
                <div className="mb-4">
                    <div className="row g-2">
                        {/* Champ de recherche */}
                        <div className="col-md-6">
                            <InputGroup>
                                <InputGroup.Text className="bg-white">
                                    <FaSearch className="text-muted" />
                                </InputGroup.Text>
                                <Form.Control
                                    type="text"
                                    placeholder="Rechercher par pseudo, téléphone, référence..."
                                    value={searchTerm}
                                    onChange={(e) => setSearchTerm(e.target.value)}
                                />
                                {searchTerm && (
                                    <Button
                                        variant="outline-secondary"
                                        onClick={() => setSearchTerm('')}
                                    >
                                        ×
                                    </Button>
                                )}
                            </InputGroup>
                        </div>

                        {/* Filtre par type */}
                        <div className="col-md-4">
                            <InputGroup>
                                <InputGroup.Text className="bg-white">
                                    <FaFilter className="text-muted" />
                                </InputGroup.Text>
                                <Form.Select
                                    value={selectedType}
                                    onChange={(e) => setSelectedType(e.target.value)}
                                >
                                    {typesCollaboration.map(type => (
                                        <option key={type.value} value={type.value}>
                                            {type.label}
                                        </option>
                                    ))}
                                </Form.Select>
                            </InputGroup>
                        </div>

                        {/* Bouton rafraîchir */}
                        <div className="col-md-2">
                            <Button
                                variant="outline-primary"
                                onClick={fetchMembres}
                                disabled={loading}
                                className="w-100"
                            >
                                <FaSyncAlt className={loading ? "fa-spin" : ""} />
                                {' '}{loading ? 'Chargement...' : 'Rafraîchir'}
                            </Button>
                        </div>
                    </div>
                </div>

                {/* Résumé des résultats */}
                <div className="d-flex justify-content-between align-items-center mb-3">
                    <small className="text-muted">
                        {filteredMembres.length} membre(s) trouvé(s)
                        {selectedType !== 'all' && ` • Filtré par ${typesCollaboration.find(t => t.value === selectedType)?.label}`}
                        {searchTerm && ` • Recherche: "${searchTerm}"`}
                    </small>
                    {filteredMembres.length !== membres.length && (
                        <Button
                            variant="link"
                            size="sm"
                            onClick={() => {
                                setSearchTerm('');
                                setSelectedType('all');
                            }}
                            className="text-decoration-none"
                        >
                            Réinitialiser les filtres
                        </Button>
                    )}
                </div>

                {/* Tableau des membres */}
                {loading ? (
                    <div className="text-center py-5">
                        <Spinner animation="border" variant="primary" />
                        <p className="mt-3 text-muted">Chargement des membres...</p>
                    </div>
                ) : error ? (
                    <div className="alert alert-danger text-center py-4">
                        <p className="mb-2">{error}</p>
                        <Button variant="outline-danger" size="sm" onClick={fetchMembres}>
                            Réessayer
                        </Button>
                    </div>
                ) : filteredMembres.length === 0 ? (
                    <div className="text-center py-5">
                        <FaUsers size={50} className="text-muted mb-3" />
                        <p className="text-muted">
                            {membres.length === 0
                                ? "Aucun membre d'organisation pour cet événement"
                                : "Aucun résultat ne correspond à vos critères"}
                        </p>
                        {(searchTerm || selectedType !== 'all') && (
                            <Button
                                variant="link"
                                onClick={() => {
                                    setSearchTerm('');
                                    setSelectedType('all');
                                }}
                            >
                                Voir tous les membres
                            </Button>
                        )}
                    </div>
                ) : (
                    <div className="table-responsive">
                        <Table hover striped className="mb-0">
                            <thead className="table-light">
                                <tr>
                                    <th>Réf. compte</th>
                                    <th>Pseudo</th>
                                    <th>Téléphone</th>
                                    <th>Type collaboration</th>
                                    <th>Réf. collaboration</th>
                                    {/* <th>Statut</th> */}
                                </tr>
                            </thead>
                            <tbody>

                                {isLoading ? (
                                    <tr>
                                        <td colSpan="4" className="text-center">Chargement...</td>
                                    </tr>
                                ) : filteredMembres.length > 0 ? (
                                    filteredMembres.map((membre, index) => {
                                        const typeBadge = getTypeBadge(membre.type_collaboration);
                                        const statutBadge = getStatutBadge(membre.statut_collaboration);

                                        return (
                                            <tr key={membre.id}>
                                                <td>
                                                    <code className="">{membre.ref_compte || '—'}</code>
                                                </td>
                                                <td>
                                                    <strong>{membre.pseudo || `${membre.prenoms} ${membre.nom}`}</strong>
                                                </td>
                                                <td>{membre.telephone || '—'}</td>
                                                <td>
                                                    <Badge bg={typeBadge.variant}>
                                                        {typeBadge.text}
                                                    </Badge>
                                                </td>
                                                <td>
                                                    <code className="">{membre.ref_collaboration || '—'}</code>
                                                </td>
                                                {/* <td>
                                                <Badge bg={statutBadge.variant}>
                                                    {statutBadge.text}
                                                </Badge>
                                            </td> */}
                                            </tr>
                                        );
                                    })
                                ) : (
                                    <tr>
                                        <td colSpan="4" className="text-center">Aucune collaboration trouvée.</td>
                                    </tr>
                                )}
                            </tbody>
                        </Table>
                    </div>
                )}
            </Modal.Body>

            <Modal.Footer className="bg-light">
                <div className="d-flex justify-content-between w-100 align-items-center">
                    <div>
                        {selectedType !== 'all' && (
                            <Badge bg="secondary" className="me-1">
                                Filtre: {typesCollaboration.find(t => t.value === selectedType)?.label}
                            </Badge>
                        )}
                        {searchTerm && (
                            <Badge bg="info">
                                Recherche: {searchTerm}
                            </Badge>
                        )}
                    </div>
                    <Button variant="secondary" onClick={onHide}>
                        Fermer
                    </Button>
                </div>
            </Modal.Footer>
        </Modal>
    );
};

export default CollaborationModal;